import { CartLinesUpdateEvent } from '@shopify/events';
import '@theme/fly-to-cart';
class PanelCart04 extends HTMLElement {
  connectedCallback() {
    if (this.bound) return; this.bound = true;
    this.querySelector('form').addEventListener('submit', e => this.add(e));
    this.querySelector('[data-size-guide-shortcut]')?.addEventListener('click', () => {
      const dialog = this.closest('.sg04');
      const tabs = [...(dialog?.querySelectorAll('.sg04-navigation button') || [])];
      const target = tabs.find((button) => /size\s*&\s*fit/i.test(button.textContent || ''));
      target?.click();
    });
  }
  async add(event) {
    event.preventDefault();
    if (this.busy) return;
    const form = event.currentTarget, button = form.querySelector('button'), status = form.querySelector('[role=status]');
    if (!form.reportValidity()) return;
    const choice = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"][type="hidden"]');
    if (!choice) return;
    this.busy = true; button.disabled = true; status.textContent = '';
    const id = choice.value, quantity = Number(choice.dataset.quantity) || 1;
    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: id, quantity }], promise: deferred.promise }));
    let added = false;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0, 5);
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity }], sections, sections_url: location.pathname }) });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
      added = true;
      const cartResponse = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!cartResponse.ok) throw new Error(this.dataset.error);
      const cart = await cartResponse.json();
      status.textContent = this.dataset.added;
      const rect = button.getBoundingClientRect();
      const modal = this.closest('dialog');
      modal?.close();
      await new Promise(resolve => requestAnimationFrame(resolve));
      this.fly(rect);
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, sections: result.sections, source: 'product-form-component', sourceId: form.id, itemCount: quantity, productId: this.dataset.productId, didError: false } });
    } catch (error) {
      deferred.reject(error);
      status.textContent = added ? this.dataset.added : error.message || this.dataset.error;
      if (added) { button.disabled = true; return; }
    } finally { this.busy = false; if (!added || !button.disabled || !status.textContent) button.disabled = false; }
    button.disabled = false;
  }
  fly(rect) {
    const destination = [...document.querySelectorAll('.header-actions__cart-icon')].find(el => el.getBoundingClientRect().width);
    if (!destination || !this.dataset.image || matchMedia('(prefers-reduced-motion: reduce)').matches || !customElements.get('fly-to-cart')) return;
    const anchor = document.createElement('span');
    Object.assign(anchor.style, { position: 'fixed', pointerEvents: 'none', left: `${rect.left}px`, top: `${rect.top}px`, width: `${rect.width}px`, height: `${rect.height}px` });
    anchor.setAttribute('aria-hidden', 'true'); document.body.append(anchor);
    const fly = document.createElement('fly-to-cart'); fly.className = 'fly-to-cart--main'; fly.style.setProperty('background-image', `url("${this.dataset.image}")`); fly.style.setProperty('--start-opacity', '0'); fly.source = anchor; fly.destination = destination; document.body.append(fly);
    setTimeout(() => { anchor.remove(); fly.remove(); }, 1800);
  }
}
if (!customElements.get('panel-cart-04')) customElements.define('panel-cart-04', PanelCart04);

if (!window.__pdpSizeGuide04Bound) {
  window.__pdpSizeGuide04Bound = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-pdp-size-guide]');
    if (!trigger) return;
    event.preventDefault();

    const scope = trigger.closest('.shopify-section') || document;
    const rows = [...scope.querySelectorAll('details[data-testid="accordion-details"]')];
    const row = rows.find((details) => /size\s*&\s*fit/i.test(details.querySelector(':scope > summary')?.textContent || ''));
    const panelButton = row?.querySelector('.sg04-panel-open');
    if (panelButton) {
      panelButton.click();
      return;
    }

    const fallback = scope.querySelector('size-fit-guide-04 [data-guide-open]');
    fallback?.click();
  });
}
